import { EventToNavigation } from './eventToNavigation';
import Event from '../Event';
import UserAuthenticationSucceed from '../../user/events/UserAuthenticationSucceed';
import { Store } from 'redux';
import UserLogoutCompleted from '../../user/events/UserLogoutCompleted';
import State from '../State';
import { History } from 'history';
import LocationDescriptor = History.LocationDescriptor;

const config: EventToNavigation[] = [
    {
        type: UserLogoutCompleted.type,
        path: (): LocationDescriptor => '/login'
    },
    {
        type: UserAuthenticationSucceed.type,
        path: (event: Event, store: Store<State>): LocationDescriptor => store.getState().user.initialLocation
    }
];

export default config;



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventToNavigationConfig.ts